// eslint-disable-next-line no-restricted-imports
import {
  ClientBusinessRelationshipDto_Input,
  Query_ClientController_GetList_AllOf_1_List_Items_BusinessRelationship_BusinessRelationshipGoals_Items as BusinessRelationshipGoalsApi,
  Query_ClientController_GetList_AllOf_1_List_Items_BusinessRelationship_InvestmentGoals_Items as InvestmentGoalsApi,
} from 'api/generated/graphql';
import { BusinessRelationshipParam } from 'api/types/params';

export const parseBusinessRelationshipParam = (
  data: BusinessRelationshipParam
): ClientBusinessRelationshipDto_Input => ({
  businessRelationshipGoals: data.businessRelationshipGoals.map(
    (goal) => BusinessRelationshipGoalsApi[goal]
  ),
  investmentGoals: data.investmentGoals.map((goal) => InvestmentGoalsApi[goal]),
  otherBusinessRelationshipGoal: data.otherBusinessRelationshipGoal,
  otherInvestmentGoal: data.otherInvestmentGoal,
});
